(() => {
  const dialog = document.getElementById('InternationalWelcome');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const dismissedKey = 'flask:international-welcome:v1';
  const detectedKey = 'flask:detected-country:v1';
  const preview = window.Shopify?.theme?.role === 'unpublished'
    && new URLSearchParams(window.location.search).get('international_preview') === 'GB';

  const remember = () => {
    if (preview) return;
    try {
      localStorage.setItem(dismissedKey, '1');
    } catch (_) {
      // Browsing must still work when storage is unavailable.
    }
  };

  for (const button of dialog.querySelectorAll('[data-welcome-close]')) {
    button.addEventListener('click', () => dialog.close());
  }
  dialog.addEventListener('close', remember);
  dialog.querySelector('form').addEventListener('submit', remember);
  dialog.querySelector('[data-welcome-change]').addEventListener('click', () => {
    dialog.querySelector('[data-welcome-actions]').hidden = true;
    dialog.querySelector('[data-welcome-picker]').hidden = false;
    dialog.querySelector('select').focus();
  });

  async function detectCountry() {
    if (preview) return { handle: 'GB', name: 'United Kingdom' };
    if (localStorage.getItem(dismissedKey)) return null;
    const cached = sessionStorage.getItem(detectedKey);
    if (cached) return JSON.parse(cached);

    const url = new URL(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json`, window.location.origin);
    url.searchParams.set('country[enabled]', 'true');
    url.searchParams.set('country[exclude]', dialog.dataset.currentCountry);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) return null;
      const country = (await response.json()).detected_values?.country;
      if (!country || !/^[A-Z]{2}$/.test(country.handle) || typeof country.name !== 'string' || !country.name) return null;
      sessionStorage.setItem(detectedKey, JSON.stringify(country));
      return country;
    } finally {
      clearTimeout(timeout);
    }
  }

  async function showWelcome() {
    try {
      const country = await detectCountry();
      if (!country || country.handle === 'US') return;
      if (document.querySelector('dialog[open]')) return;
      dialog.querySelector('[data-welcome-country]').textContent = country.name;
      dialog.showModal();
    } catch (_) {
      // No popup if detection, storage, or browser support fails.
    }
  }

  showWelcome();
})();
